import { Gauge } from "lucide-react";
import {
  KpiTileParamsSchema,
  defaultKpiTileParams,
  DEFAULT_KPI_TILE_RANGE,
  type KpiTileParams,
  type KpiTileRange,
} from "@playbookai/widget-schemas";
import type { WidgetDef } from "../types.js";
import { registerWidget } from "../registry.js";
import { KpiTileWidget } from "./Component.js";

/** The window labels, shared with the editor's range control. */
export const KPI_TILE_RANGE_LABEL: Record<KpiTileRange, string> = {
  "30d": "Last 30 days",
  "90d": "Last 90 days",
  all: "All time",
};

export const kpiTileDef: WidgetDef<KpiTileParams> = {
  kind: "kpiTile",
  label: "KPI Tile",
  modes: ["canvas", "dashboard"],
  singleton: false,
  defaultSize: { w: 352, h: 324 },
  defaultParams: defaultKpiTileParams,
  Component: KpiTileWidget,
  storage: "sql",
  schema: KpiTileParamsSchema,
  accent: "cyan",
  icon: Gauge,
  subtitle: "Linked KPI",
  renderTitle: (data) => data.label.trim() || "KPI Tile",
  // The title and footer are the only places the def can speak, and it sees the
  // PARAMS, not the resolved KPI — so they state the BINDING and leave the
  // measurement to the body. Restating a value here would mean caching one.
  renderSubtitle: (data) =>
    data.kpiId ? "Linked KPI" : data.legacy ? "Not linked" : "Choose a KPI",
  defaultRoster: false, // addable from "+ Widget" only
  category: "multi",
  layout: { col: 1, row: 1, width: 352, height: 300 },
  expandable: true,
  renderFooter: (data) => ({
    left: data.kpiId ? "Source: KPI Manager" : "No KPI linked",
    right: data.kpiId
      ? KPI_TILE_RANGE_LABEL[data.range ?? DEFAULT_KPI_TILE_RANGE]
      : "",
  }),
};

registerWidget(kpiTileDef);
